import type { ApiBody, ApiResponse } from '../../api/contract';
import type { ListQuery } from '../../shared/data/types';

export type CommissionRuleDetail = ApiResponse<'/api/v1/commission-rules/{id}', 'get'>['data'];
export type CommissionRuleSummary = CommissionRuleDetail;
export type CommissionRulePreviewInput = ApiBody<'/api/v1/commission-rules/preview', 'post'>;
export type CommissionRulePreview = ApiResponse<'/api/v1/commission-rules/preview', 'post'>['data'];
export type CommissionRuleCreateInput = ApiBody<'/api/v1/commission-rules', 'post'>;
export type PublishRuleInput = ApiBody<'/api/v1/commission-rules/{id}/publish', 'post'>;
export type CancelRuleInput = ApiBody<'/api/v1/commission-rules/{id}/cancel', 'post'>;
export type CommissionRuleScope = CommissionRuleDetail['scope'];
export type CommissionRuleLifecycle = CommissionRuleDetail['lifecycle'];
export type CommissionRulePhase = CommissionRuleDetail['phase'];
export type CommissionRuleSort = 'version' | 'lifecycle' | 'effectiveFrom' | 'createdAt';

export interface CommissionRuleFilters {
  readonly scope: CommissionRuleScope | '';
  readonly partnerId: string;
  readonly gameTypeId: string;
  readonly gameId: string;
  readonly lifecycle: CommissionRuleLifecycle | '';
  readonly phase: CommissionRulePhase | '';
  readonly effectiveFrom: string;
  readonly effectiveTo: string;
}

export type CommissionRuleListQuery = ListQuery<CommissionRuleSort, CommissionRuleFilters>;

export function bangkokWallTimeToRfc3339(value: string): string {
  const trimmed = value.trim();
  if (trimmed.length === 0) return '';
  if (/(?:Z|[+-]\d{2}:\d{2})$/u.test(trimmed)) return trimmed;
  const match = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})(?::(\d{2})(\.\d{1,3})?)?$/u.exec(trimmed);
  if (match === null) throw new Error('Expected a Bangkok wall time');
  return `${match[1]}:${match[2] ?? '00'}${match[3] ?? ''}+07:00`;
}
